import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { subscribeEntities } from 'home-assistant-js-websocket';
import type { Connection, HassEntities, HassEntity } from 'home-assistant-js-websocket';

const STATES_QUERY_KEY = ['ha', 'states'] as const;

export function useHAStates(connection: Connection | null) {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!connection) return;
    const unsub = subscribeEntities(connection, (entities) => {
      queryClient.setQueryData<HassEntities>(STATES_QUERY_KEY, entities);
    });
    return () => {
      unsub();
    };
  }, [connection, queryClient]);

  return useQuery<HassEntities>({
    queryKey: STATES_QUERY_KEY,
    queryFn: () => ({} as HassEntities),
    enabled: !!connection,
    staleTime: Infinity,
  });
}

export function useEntityState(entityId: string, connection: Connection | null): HassEntity | null {
  const { data: entities } = useHAStates(connection);
  return entities?.[entityId] ?? null;
}
